export const SET_SUBMISSION_TABLE = "SET_SUBMISSION_TABLE";
export const SET_NEW_MESSAGE_COUNT = "SET_NEW_MESSAGE_COUNT";
export const LOAD_MESSAGE_SUMMARIES = "LOAD_MESSAGE_SUMMARIES";
